import React from "react";

export default function ModalClose(props) {

    return (
        <>
            <div className={'position-absolute top-0 end-0 me-2 mt-1 d-none d-sm-block'} style={{zIndex: 9999999}}>
                <span role={'button'} onClick={() => props.onClose(false)} className={'link-dark fs-5'}>
                    <i className={`fal fa-times text-${props.color}`}></i></span>
            </div>
            <div className={'position-absolute top-0 end-5 d-sm-none'} style={{zIndex: 9999999}}>
                <span role={'button'} onClick={() => props.onClose(false)} className={'link-dark fs-4'}><i className={`fal fa-times text-${props.color}`}></i></span>
            </div>
        </>
    )
}